import { useState, type ReactNode } from "react";
import { IconDownload } from "./icons";
import { downloadAuthenticated } from "../lib/download";

export function FileDownloadButton({
  url,
  filename,
  label,
  className = "header-action",
}: {
  url: string;
  filename: string;
  label: string;
  className?: string;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);

  return (
    <span className="file-download">
      <button
        type="button"
        className={className}
        disabled={busy}
        onClick={() => {
          setBusy(true);
          setError(null);
          setOk(null);
          void downloadAuthenticated(url, filename)
            .then((result) => {
              setOk(
                result.saved
                  ? `Saved ${filename} to ${result.folder ?? "Downloads"}`
                  : `Downloading ${filename}…`,
              );
            })
            .catch((err) => setError(err instanceof Error ? err.message : "Download failed"))
            .finally(() => setBusy(false));
        }}
      >
        <IconDownload />
        <span>{busy ? "Saving…" : label}</span>
      </button>
      {ok && <p className="form-success">{ok}</p>}
      {error && <p className="form-error">{error}</p>}
    </span>
  );
}

export function FileDownloadLink({
  url,
  filename,
  children,
}: {
  url: string;
  filename: string;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      className="topbar-link"
      onClick={() => {
        void downloadAuthenticated(url, filename);
      }}
    >
      {children}
    </button>
  );
}
